import React from "react";
import { Button, ButtonProps, Collapse, SxProps } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { ISearchForm } from "redux/searchForm";

interface IProps {
  sx: SxProps;
  variant?: ButtonProps["variant"];
  handleNavigate: () => void;
  searchForm: ISearchForm;
  buttonWidth?: number | string;
  size?: "small" | "medium" | "large" | "xLarge";
}

export const LowpriceCalendarLink = (props: IProps) => {
  const {
    sx,
    variant = "contained",
    handleNavigate,
    searchForm,
    buttonWidth = "100%",
    size = "large",
  } = props;

  const { title } = useTranslations().translations.lowPriceCalendar;

  return (
    <Collapse
      in={
        searchForm.flights.length === 2 ||
        (searchForm.tripType === "ONE_WAY" && searchForm.flights.length === 1)
      }
      mountOnEnter
      sx={sx}
      timeout={"auto"}
    >
      <Button
        variant={variant}
        size={size}
        onClick={handleNavigate}
        sx={{ width: buttonWidth }}
      >
        <CalendarMonthOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
        {title}
      </Button>
    </Collapse>
  );
};
